import { render, staticRenderFns } from "./AlarmHeaderModal.vue?vue&type=template&id=4fa875a4&scoped=true&"
import script from "./AlarmHeaderModal.vue?vue&type=script&lang=js&"
export * from "./AlarmHeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./AlarmHeaderModal.vue?vue&type=style&index=0&id=4fa875a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa875a4",
  null
  
)

export default component.exports